export default __webpack_public_path__ + "static/media/banner-image-5.10e57017.jpg";